module.exports = __webpack_public_path__ + "static/media/InSports.a8578bb6.svg";